import commonIcon from '@/components/common-icon'
import BaseConfig from '@/config/base-config'
export default {
  components: {
    commonIcon
  },
  methods:{
    getTitle:(item) => {
      return (item.meta && item.meta.title) || item.name
    },
    //是否展示下级目录   有子目录并且子目录数量大于1
    showChildren(item) {
      return item.children && (item.children.length > 1 || (item.meta && item.meta.showAlways))
    },
    /**
     * 获取目录跳转地址
     * @param item
     * @param children0 bool 是否有子目录
     * @returns {string}
     */
    getNameOrHref (item, children0) {
      // return item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name)
      return item.href ? `${item.href}` : (children0 ? item.children[0].name : item.name)
    }
  },
  computed:{
    default_menu_icon: () => {
      return BaseConfig.DEFAULT_MENU_ICON
    }
  }

}


